// Keep the explicitly selected Shopify language on internal storefront links.
// Customer language and account data from VARIO are never written here.
(() => {
  function localizeLinks(scope = document) {
    const root = document.querySelector('[data-wj-locale-root]')?.dataset.wjLocaleRoot;
    if (!root) return;
    const lang=document.documentElement.lang.split('-')[0];
    scope.querySelectorAll('a[href^="/apps/b2b"]').forEach(link=>{const url=new URL(link.getAttribute('href'),location.origin);url.searchParams.set('lang',lang);link.setAttribute('href',url.pathname+url.search+url.hash)});
    if(root==='/')return;
    const prefix = root.replace(/\/$/, '');
    scope.querySelectorAll('a[href]').forEach(link => {
      const href = link.getAttribute('href');
      if (/^\/(?:collections|products|pages|search|cart)(?:[/?#]|$)/.test(href)) {
        link.setAttribute('href', prefix + href);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => localizeLinks());
  else localizeLinks();
  document.addEventListener('shopify:section:load', event => localizeLinks(event.target));
})();
